export const CREATE_TEAM_DRAWER_ID = 'create-team-drawer';
export const EDIT_TEAM_DRAWER_ID = 'edit-team-drawer';

export const NONE_OPTION_VALUE = '- none -';

export const CREATE_TEAM_INPUT_MAX_LENGTH = 50;
